import StarIconFilled from '@atlaskit/icon/glyph/star-filled';
import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import { TOTAL_STARS } from './Ratings.constants';
import { AverageStars, Divider, NumericRatingStyled, RatingsContainer, RatingsCountStyled, StarIconContainer, StarRatingStyled } from './Ratings.styles';
import { getStarVariations, roundRatingToOneDecimal } from './Ratings.utils';
import { StarGradients } from './StarGradients';
const NumericRating = _ref => {
  let {
    avgStars
  } = _ref;
  return /*#__PURE__*/React.createElement(NumericRatingStyled, null, /*#__PURE__*/React.createElement(AverageStars, null, roundRatingToOneDecimal(avgStars)), /*#__PURE__*/React.createElement(Divider, null, "/"), /*#__PURE__*/React.createElement("span", null, TOTAL_STARS));
};
const StarRating = props => {
  const stars = getStarVariations(props.ratings);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StarGradients, null), /*#__PURE__*/React.createElement(StarRatingStyled, null, stars.map((variation, index) => /*#__PURE__*/React.createElement(StarIconContainer, {
    key: index,
    variation: variation,
    "data-testid": "star-rating-".concat(variation)
  }, /*#__PURE__*/React.createElement(StarIconFilled, {
    label: "Star rating"
  })))));
};
const RatingsCount = _ref2 => {
  let {
    numRatings
  } = _ref2;
  return /*#__PURE__*/React.createElement(RatingsCountStyled, null, "(", numRatings, ")");
};
export const Ratings = props => {
  const {
    avgStars,
    numRatings
  } = props.ratings;
  return /*#__PURE__*/React.createElement(RatingsContainer, {
    "data-testid": TEST_IDS.RATINGS
  }, !!numRatings && /*#__PURE__*/React.createElement(NumericRating, {
    avgStars: avgStars
  }), /*#__PURE__*/React.createElement(StarRating, {
    ratings: props.ratings
  }), !!numRatings && /*#__PURE__*/React.createElement(RatingsCount, {
    numRatings: numRatings
  }));
};